import { createActionsHook } from 'src/lib/sweetState';

import { PerformanceStore } from './PerformanceStore';

export const usePerformanceActions = createActionsHook(PerformanceStore);
